function About () {
    return(
        <div className="about">
            <div className="abt">
                <h1>ABOUT</h1>
            </div>
        </div>
    );
}

export default About;